export class Expiration {
  static Never = -1;
  static Now = 0;
  static Minute = 60000;
  static Hour = 3600000;
  static Day = 86400000;
  static Week = 604800000;
}
